






























































































































import { Component, Vue } from "vue-property-decorator";
import {
  getTodayNewServerList,
  getFutureNewServerList,
  getTimeSection,
  tagList,
} from "@/req/home";
import qs from "@/components/queSheng.vue";
@Component({
  components: { qs },
})
export default class Home extends Vue {
  public active = "toDay";
  public activeHistory = "";
  public versionList: any = [];
  public cityList = [];
  public limit = "toDay";
  public columns = [
    {
      title: "开服时间",
      slot: "open_time",
      align: "center",
      width: 150,
      //   render: (h, params) => {
      //     return h(
      //       "span",
      //       {
      //         props: {},
      //       },
      //       this.$fn.toDateSymbol(params.row.open_time)
      //     );
      //   },
    },
    {
      title: "游戏名称",
      slot: "game_name",
      align: "center",
      width: 200,
    },
    {
      title: "特色",
      key: "game_tags",
      align: "center",
      width: 100,
    },
    {
      title: "介绍",
      key: "game_desc",
      slot: "game_desc",
      align: "center",
    },
    {
      title: "开始游戏",
      key: "begin",
      slot: "begin",
      align: "center",
      width: 120,
    },
    /* {
      title: "官网",
      slot: "web",
      align: "center",
      width: 80,
    }, */
  ];
  public data: any = [];
  public model1 = "";
  public sStime = "";
  public eEtime = "";
  public size = 50;
  public page = 1;
  public versionid = "-1";
  public tag = "-1";
  public timeList: any = [];
  public time = "-1";
  public timer: any = null; // 定时
  public nums = 0;

  public mounted() {
    window.addEventListener("scroll", this.add);
    this.getTime();
    this.getList();
    this.getTag();
  }
  public add() {
    const a = document.documentElement.scrollTop;
    const b = document.documentElement.clientHeight;
    const c = document.documentElement.scrollHeight;
    if (c - a - b < 1) {
      if (this.nums > this.data.length) {
        this.page = this.page + 1;
        this.getList();
      }
    }
  }
  public destroyed() {
    clearTimeout(this.timer);
    window.removeEventListener("scroll", this.add);
  }
  public getUrl(url) {
    let strURL = "";
    if (
      url.substr(0, 7).toLowerCase() == "http://" ||
      url.substr(0, 8).toLowerCase() == "https://"
    ) {
      strURL = url;
    } else {
      strURL = "http://" + url;
    }
    // window.open(strURL, "_blank")
    window.location.href = strURL;
  }
  public async getList() {
    if (this.active != this.activeHistory) {
      this.data = [];
    }
    // this.data = [];
    const obj = {
      token: this.$fn.cookies.getToken(),
      section_id: this.time == "-1" ? "" : this.time,
      size: this.size,
      page: this.page,
      versionid: this.versionid == "-1" ? "" : this.versionid,
      tag: this.tag == "-1" ? "" : this.tag,
    };
    let res;
    if (this.active == "toDay") {
      this.activeHistory = this.active;
      res = await getTodayNewServerList(obj);
    } else {
      this.activeHistory = this.active;
      res = await getFutureNewServerList(obj);
    }
    if (res.code == 200) {
      //   const newArr = res.data.game_info.data;
      const newArr = [...this.data, ...res.data.game_info.data];
      this.data = newArr;
      this.nums = res.data.game_info.total;
      this.timer = setTimeout(() => {
        this.page = 1;
        this.nums = 0;
        this.data = [];
        this.getList();
        // 下一次刷新时间
      }, res.data.next_time * 1000);
    }
  }
  public async getTime() {
    const res = await getTimeSection({ token: this.$fn.cookies.getToken() });
    if (res.code == 200) {
      this.timeList = res.data.time_section;
    }
  }
  public async getTag() {
    const res = await tagList({ token: this.$fn.cookies.getToken() });
    if (res.code == 200) {
      this.cityList = res.data.tagList;
      this.versionList = res.data.versionList;
    }
  }
  public rowClick(item) {
    const detailid = item.box_game_id + ".html";
    window.App.$router.push(`/myGame/gameDetail/${99}/${99}/${1}/${detailid}`);
    // this.$router.push({
    //   path: "/myGame/gameDetail",
    //   query: { id: item.box_game_id, type: "2" },
    // });
  }
  public changeDate() {
    this.data = [];
    this.nums = 0;
    this.page = 1;
    this.getList();
  }
  public getNavbtn(name) {
    this.limit = name;
    this.data = [];
    this.nums = 0;
    this.page = 1;
    this.activeHistory = this.active;
    this.active = name;
    this.getList();
  }
}
